import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

import { getResourceTo } from 'react/utils/utils';

function ProfileMenuItem({ children, id, title, isOpen, onClick }) {
  const className = useMemo(() => {
    if (children && isOpen) {
      return 'has-submenu open';
    } else if (children) {
      return 'has-submenu';
    }

    return '';
  }, [children, isOpen]);

  return (
    <div
      data-testid={`menu-${id}`}
      className={`menu-item ${className}`}
    >
      <div
        data-testid={`menuItem-${id}`}
        className="menu-content"
        onClick={onClick}
      >
        {getResourceTo(title)}
      </div>
      <div data-testid={`submenu-content-${id}`} className="submenu-content">
        {children}
      </div>
    </div>
  );
}

ProfileMenuItem.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func
};

ProfileMenuItem.defaultProps = {
  isOpen: false,
  onClick: () => null
};

export default memo(ProfileMenuItem);
